import HttpClient from "../base/http-client";

export default class ShipperClient extends HttpClient {
    constructor() {
        super("shipper", true);
    }
}
